import React from 'react';
import Menu from '../components/Menu';
import './ExternalPage.css';

const PLAN_DISC_URL = 'https://create.plandisc.com/wheel/showPublic/6Yx3Xac';

export const ExternalPage = () => {
    return(
        <div className="App">
            <Menu/>
            <div className='external-page'>
                <iframe
                    src={PLAN_DISC_URL}
                    title="Plandisc"
                    className='external-page-iframe'
                    loading="lazy"
                    allowFullScreen={false}
                    sandbox="allow-scripts allow-same-origin"
                    referrerPolicy="no-referrer"
                />
            </div>
        </div>
    )
};
